export default {
  'background-default': 'fixed-article-banner-img',
  'article-detail-background-img':
    'article-detail-background-img lg:w-articleContainer mx-auto sm:pl-70 sm:pr-0 lg:px-0 sm:mb-20 lg:my-24 inline-block w-full',
  'background-no-left-padding':
    'article-detail-background-img lg:w-innerContainer mx-auto sm:pl-0 sm:pr-0 lg:px-0 sm:mb-30 inline-block',
  imageHeight: 'md:pt-40p sm:pt-45p',
  parallax: 'parallax',
  'article-detail-banner': 'fixed-article-banner-img',
  powerOfHairBgImg: 'fixed-article-banner-img powerOfHairBgImg',
  bestVitaminForHair: 'fixed-article-banner-img bestVitaminForHair',
};
